/**
 * AW Drawer
 * Thin wrapper around MicroModal for slide-in drawers.
 *
 * Drawer markup:
 *   <div id="<id>" class="aw-drawer aw-drawer--right" aria-hidden="true">
 *     <div class="aw-drawer__overlay" tabindex="-1" data-aw-drawer-close></div>
 *     <div class="aw-drawer__container" role="dialog" aria-modal="true" aria-labelledby="<id>-title">
 *       <header class="aw-drawer__header">
 *         <h2 id="<id>-title" class="aw-drawer__title">...</h2>
 *         <button class="aw-drawer__close" data-aw-drawer-close aria-label="Close">{% render 'icon-close' %}</button>
 *       </header>
 *       <div class="aw-drawer__body">...</div>
 *     </div>
 *   </div>
 *
 * Trigger:  [data-aw-drawer-trigger="<id>"]
 * Content:  id="<id>"  [data-aw-drawer-content]  class="aw-drawer aw-drawer--right|left"
 * Close:    [data-aw-drawer-close]  (inside the drawer)
 */

(function () {
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;

    drawer.classList.remove('aw-drawer--closing');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Focus first focusable element
    const focusable = drawer.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) setTimeout(() => focusable.focus(), 50);

    // Trap Escape key
    drawer._escHandler = (e) => { if (e.key === 'Escape') closeDrawer(id); };
    document.addEventListener('keydown', drawer._escHandler);
  }

  function closeDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer || !drawer.classList.contains('is-open')) return;

    drawer.classList.add('aw-drawer--closing');

    // Wait for slide-out animation to finish before hiding
    const container = drawer.querySelector('.aw-drawer__container');
    const onEnd = () => {
      drawer.classList.remove('is-open', 'aw-drawer--closing');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      container.removeEventListener('animationend', onEnd);
    };
    container.addEventListener('animationend', onEnd);

    if (drawer._escHandler) {
      document.removeEventListener('keydown', drawer._escHandler);
      delete drawer._escHandler;
    }
  }

  function init() {
    // Open triggers: data-aw-drawer-trigger="drawer-id"
    document.querySelectorAll('[data-aw-drawer-trigger]').forEach((btn) => {
      if (btn.dataset.awDrawerInit) return;
      btn.dataset.awDrawerInit = '1';
      btn.addEventListener('click', () => openDrawer(btn.dataset.awDrawerTrigger));
    });

    // Close triggers: data-aw-drawer-close (inside any drawer)
    document.querySelectorAll('[data-aw-drawer-close]').forEach((el) => {
      if (el.dataset.awDrawerCloseInit) return;
      el.dataset.awDrawerCloseInit = '1';
      el.addEventListener('click', () => {
        const drawer = el.closest('.aw-drawer');
        if (drawer) closeDrawer(drawer.id);
      });
    });
  }

  // Expose globally so Liquid/other scripts can call AW.drawer.open/close
  window.AW = window.AW || {};
  window.AW.drawer = { open: openDrawer, close: closeDrawer };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();